import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';


@NgModule({
    imports: [AuthModule.forRoot({
        config: {
              authority: 'https://accounts.google.com',
              redirectUrl: 'http://localhost:4200/uzivatel/prihlasit',
              postLogoutRedirectUri: 'http://localhost:4200/uzivatel/prihlasit',
              clientId: '244767285438-depsfibc7dbc6ciq656v6g6fl53g4poj.apps.googleusercontent.com',
              scope: 'openid profile email', // 'openid profile offline_access ' + your scopes
              responseType: 'code',
              silentRenew: true,
              useRefreshToken: true,
              renewTimeBeforeTokenExpiresInSeconds: 30,
          }
      })],
    exports: [AuthModule],
})
export class AuthConfigModule {}
